import React from 'react';
import { Checkbox as RNPCheckbox } from 'react-native-paper';

type CheckboxProps = React.ComponentProps<typeof RNPCheckbox>;

export default function Checkbox(props: CheckboxProps) {
  return <RNPCheckbox {...props} />;
}
